import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../../../../../services/account.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';

@Component({
  selector: 'app-change-subscription-dialog',
  templateUrl: './change-subscription-dialog.component.html',
  styleUrls: ['./change-subscription-dialog.component.css']
})
export class ChangeSubscriptionDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  subscriptionType: any;
  changeSubscriptionText: string;
  subscriptionDetails: any;
  subscriptionMessage: string;
  configData: any = {};
  licSubscriptionTypeDetails: any;
  monthly: any;
  annual: any;
  constructor(private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
      private accountService: AccountService, private commonfilter: CommonfilterService) {

    this.commonfilter.getConfigData()
    .subscribe(res => {
     this.configData = res;
     console.log(JSON.stringify(this.configData));
     this.licSubscriptionTypeDetails = this.configData.licSubscriptionTypeDetails;
    //  this.monthly =  this.licSubscriptionTypeDetails.filter(function(details) {
    //   return details.name === 'Monthly';
    // });
    // this.annual =  this.licSubscriptionTypeDetails.filter(function(details) {
    //   return details.name === 'Annual';
    // });
    //  this.monthly = this.licSubscriptionTypeDetails.monthly;
    //  this.annual = this.licSubscriptionTypeDetails.annual;
     });
   }

  ngOnInit() {
    this.subscriptionDetails = this.data['details'];
    this.subscriptionType = this.subscriptionDetails.licSubType;
    console.log('monthly.....' + JSON.stringify(this.monthly));
    console.log('annual.....' + this.annual);
    if (this.subscriptionType === 'MONTHLY') {
      if (this.subscriptionDetails.subscriptionTo === 1 ) {
        this.subscriptionType = 'ANNUAL';
        this.changeSubscriptionText = 'MONTHLY';
        this.subscriptionMessage = 'Subscription changed successfully';
      } else {
        this.changeSubscriptionText = 'ANNUAL';
        this.subscriptionMessage = 'Annual subscription is successfully initiated, it will get reflected on next bill cycle;';
      }
    } else if (this.subscriptionType === 'ANNUAL') {
      if (this.subscriptionDetails.subscriptionTo === 0) {
        this.subscriptionType = 'MONTHLY';
        this.changeSubscriptionText = 'ANNUAL';
        this.subscriptionMessage = 'Susbcription changed successfully';
      } else {
        this.changeSubscriptionText = 'MONTHLY';
        this.subscriptionMessage = 'Subscription changed successfully;';
      }

    }
   }

 onConfirm() {
  this.api_error = '';
  this.api_success = '';
  this.disableConfirmbtn = true;
  this.accountService.changeLicenseSubscription(this.changeSubscriptionText, this.data['accountId'])
  .subscribe(
    data => {
    this.api_success = this.subscriptionMessage;
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
        }, 2000);
      },
   (error) => {
    this.api_error = error.error;
    this.disableConfirmbtn = false;
    }
  );

}
}
